module.exports = __webpack_public_path__ + "img/icon_VIDA.6dda036c.svg";